import Vue from 'vue'
import Router from 'vue-router'
import 'nprogress/nprogress.css'

Vue.use(Router)

const Login = () => import(/* webpackChunkName: "login" */ 'src/components/Login.vue')
const LoginOauth = () => import(/* webpackChunkName: "loginAuth" */ 'src/components/LoginOauth.vue')
const DashboardLayout = () => import(/* webpackChunkName: "dashboardLayout" */ '@/components/Dashboard/Layout/DashboardLayout.vue')
const ExternalLayout = () => import(/* webpackChunkName: "externalLayout" */ '@/components/ExternalLayout.vue')
const PasswordReset = () => import(/* webpackChunkName: "sysPasswordReset" */ '@/components/PasswordReset.vue')
const Register = () => import(/* webpackChunkName: "sysRegister" */ '@/components/Register.vue')

const Overview = () => import(/* webpackChunkName: "overview" */ '@/components/Dashboard.vue')
const NotFoundPage = () => import(/* webpackChunkName: "notFoundPage" */ 'src/components/GeneralViews/NotFoundPageSimple.vue')
const Demo2b = () => import(/* webpackChunkName: "myCompanies" */ 'src/components/Demo2b.vue')
const Demo4 = () => import(/* webpackChunkName: "familySort" */ 'src/components/Demo4/')
const Invite = () => import(/* webpackChunkName: "invite" */ 'src/components/Invite.vue')

// const UserContainer = () => import(/* webpackChunkName: "userContainer" */ 'src/components/user/container/')
// const UserEditor = () => import(/* webpackChunkName: "userContainer" */ 'src/components/user/editor/Editor.vue')
const UserContainer = () => import(/* webpackChunkName: "UserContainer" */ '@/components/admin/user/Container.vue')
const UserEditor = () => import(/* webpackChunkName: "UserEditor" */ '@/components/admin/user/Editor.vue')

const userModules = [{
  path: 'user',
  name: 'userContainer',
  component: UserContainer
}, {
  path: 'user/:mode/:id',
  name: 'userEditor',
  component: UserEditor
}]

// admins
const AdminContainer = () => import(/* webpackChunkName: "AdminContainer" */ 'src/components/root/admin/filetejs/')
const AdminEditor = () => import(/* webpackChunkName: "AdminEditor" */ '@/components/root/admin/filetejs/editor/Editor.vue')
const administratorsModules = [{
  path: 'admin',
  name: 'AdminContainer',
  component: AdminContainer
}, {
  path: 'admin/:mode/:id',
  name: 'AdminEditor',
  component: AdminEditor
}]
// company
const CompanyContainer = () => import(/* webpackChunkName: "CompanyContainer" */ 'src/components/company/filetejs/')
const CompanyEditor = () => import(/* webpackChunkName: "CompanyEditor" */ '@/components/company/filetejs/editor/Editor.vue')
const companyModules = [{
  path: 'company',
  name: 'CompanyContainer',
  component: CompanyContainer
}, {
  path: 'company/:mode/:id',
  name: 'CompanyEditor',
  component: CompanyEditor
}]

// links
const AppsLinksLinkContainer = () => import(/* webpackChunkName: "AppsAppsLinksLinkContainer" */ 'src/components/apps/links/link/Container.vue')
const AppsLinksLinkEditor = () => import(/* webpackChunkName: "AppsLinksLinkEditor" */ '@/components/apps/links/link/Editor.vue')

// catalyst version nueva
const AppsCatalystContactContainer = () => import(/* webpackChunkName: "AppsCatalystContactContainer" */ '@/components/apps/catalyst/contact/Container.vue')
const AppsCatalystContactEditor = () => import(/* webpackChunkName: "AppsCatalystContactEditor" */ '@/components/apps/catalyst/contact/Editor.vue')

const AppsCatalystDraftContainer = () => import(/* webpackChunkName: "AppsCatalystDraftContainer" */ '@/components/apps/catalyst/draft/Container.vue')
const AppsCatalystDraftEditor = () => import(/* webpackChunkName: "AppsCatalystDraftEditor" */ '@/components/apps/catalyst/draft/Editor.vue')

const AppsCatalystQuoteContainer = () => import(/* webpackChunkName: "AppsCatalystQuoteContainer" */ '@/components/apps/catalyst/quote/Container.vue')
const AppsCatalystQuoteEditor = () => import(/* webpackChunkName: "AppsCatalystQuoteEditor" */ '@/components/apps/catalyst/quote/Editor.vue')

// catalyst-admins
const AppsCatalystCategoryContainer = () => import(/* webpackChunkName: "AppsCatalystCategoryContainer" */ '@/components/apps/catalyst/category/Container.vue')
const AppsCatalystCategoryEditor = () => import(/* webpackChunkName: "AppsCatalystCategoryEditor" */ 'src/components/apps/catalyst/category/Editor.vue')

const AppsCatalystItemAvailableContainer = () => import(/* webpackChunkName: "AppsCatalystItemAvailableContainer" */ '@/components/apps/catalyst/item-available/Container.vue')
const AppsCatalystItemAvailableEditor = () => import(/* webpackChunkName: "AppsCatalystItemAvailableEditor" */ 'src/components/apps/catalyst/item-available/Editor.vue')

const AppsCatalystDayPhotoContainer = () => import(/* webpackChunkName: "AppsCatalystDayPhotoContainer" */ '@/components/apps/catalyst/day-photo/Container.vue')
const AppsCatalystDayPhotoEditor = () => import(/* webpackChunkName: "AppsCatalystDayPhotoEditor" */ 'src/components/apps/catalyst/day-photo/Editor.vue')
const AppsCatalystIncluyeContainer = () => import(/* webpackChunkName: "AppsCatalystIncluyeContainer" */ '@/components/apps/catalyst/incluye/Container.vue')
const AppsCatalystIncluyeEditor = () => import(/* webpackChunkName: "AppsCatalystIncluyeEditor" */ 'src/components/apps/catalyst/incluye/Editor.vue')

const AppsCommonSwitcherContainer = () => import(/* webpackChunkName: "AppsCommonSwitcherContainer" */ '@/components/apps/common/switcher/Container.vue')

const AppsCommon = [
  {
    path: 'common/switcher',
    name: 'AppsCommonSwitcherContainer',
    component: AppsCommonSwitcherContainer
  }, {
    path: 'common/switcherOld',
    name: 'Demo2b',
    component: Demo2b
  }
]

const AppsLinksModules = [
  {
    path: 'links/link',
    name: 'AppsLinksLinkContainer',
    component: AppsLinksLinkContainer
  }, {
    path: 'links/link/:mode/:id',
    name: 'AppsLinksLinkEditor',
    component: AppsLinksLinkEditor
  }
]

const AppsCatalystModules = [
  {
    path: 'catalyst/quote',
    name: 'AppsCatalystQuoteContainer',
    component: AppsCatalystQuoteContainer
  }, {
    path: 'catalyst/quote/:mode/:id',
    name: 'AppsCatalystQuoteEditor',
    component: AppsCatalystQuoteEditor
  }, {
    path: 'catalyst/draft',
    name: 'AppsCatalystDraftContainer',
    component: AppsCatalystDraftContainer
  }, {
    path: 'catalyst/draft/:mode/:id',
    name: 'AppsCatalystDraftEditor',
    component: AppsCatalystDraftEditor
  },
  {
    path: 'catalyst/category',
    name: 'AppsCatalystCategoryContainer',
    component: AppsCatalystCategoryContainer
  }, {
    path: 'catalyst/category/:mode/:id',
    name: 'AppsCatalystCategoryEditor',
    component: AppsCatalystCategoryEditor
  },
  {
    path: 'catalyst/item-available',
    name: 'AppsCatalystItemAvailableContainer',
    component: AppsCatalystItemAvailableContainer
  }, {
    path: 'catalyst/item-available/:mode/:id',
    name: 'AppsCatalystItemAvailableEditor',
    component: AppsCatalystItemAvailableEditor
  },
  {
    path: 'catalyst/contact',
    name: 'AppsCatalystContactContainer',
    component: AppsCatalystContactContainer
  }, {
    path: 'catalyst/contact/:mode/:id',
    name: 'AppsCatalystContactEditor',
    component: AppsCatalystContactEditor
  }, {
    path: 'catalyst/day-photo',
    name: 'AppsCatalystDayPhotoContainer',
    component: AppsCatalystDayPhotoContainer
  }, {
    path: 'catalyst/day-photo/:mode/:id',
    name: 'AppsCatalystDayPhotoEditor',
    component: AppsCatalystDayPhotoEditor
  }, {
    path: 'catalyst/incluye',
    name: 'AppsCatalystIncluyeContainer',
    component: AppsCatalystIncluyeContainer
  }, {
    path: 'catalyst/incluye/:mode/:id',
    name: 'AppsCatalystIncluyeEditor',
    component: AppsCatalystIncluyeEditor
  }
]

// pm
const PMProjectContainer = () => import(/* webpackChunkName: "PMProjectContainer" */ 'src/components/apps/pm/project/filetejs/')
const PMProjectEditor = () => import(/* webpackChunkName: "PMProjectEditor" */ '@/components/apps/pm/project/filetejs/editor/Editor.vue')
const PMProjectModules = [{
  path: 'pm/project',
  name: 'PMProjectContainer',
  component: PMProjectContainer
}, {
  path: 'pm/project/:mode/:id',
  name: 'PMProjectEditor',
  component: PMProjectEditor
}]
// pm2
const PMTopicContainer = () => import(/* webpackChunkName: "PMTopicContainer" */ 'src/components/apps/pm/topic/filetejs/')
const PMTopicEditor = () => import(/* webpackChunkName: "PMTopicEditor" */ '@/components/apps/pm/topic/filetejs/editor/Editor.vue')
const PMTopicModules = [{
  path: 'pm/topic',
  name: 'PMTopicContainer',
  component: PMTopicContainer
}, {
  path: 'pm/topic/:mode/:id',
  name: 'PMTopicEditor',
  component: PMTopicEditor
}]
// pm3
const PMTaskContainer = () => import(/* webpackChunkName: "PMTaskContainer" */ 'src/components/apps/pm/task/filetejs/')
const PMTaskEditor = () => import(/* webpackChunkName: "PMTaskEditor" */ '@/components/apps/pm/task/filetejs/editor/Editor.vue')
const PMTaskModules = [{
  path: 'pm/task',
  name: 'PMTaskContainer',
  component: PMTaskContainer
}, {
  path: 'pm/task/:mode/:id',
  name: 'PMTaskEditor',
  component: PMTaskEditor
}]
// task sorter
const PMTaskSorterContainer = () => import(/* webpackChunkName: "PMTaskSorterContainer" */ 'src/components/apps/pm/task-sort/filetejs/')
const PMTaskSorterModules = [{
  path: 'pm/task-sort',
  name: 'PMTaskSorterContainer',
  component: PMTaskSorterContainer
}]
// pm4
const PMGanttContainer = () => import(/* webpackChunkName: "PMGanttContainer" */ 'src/components/apps/pm/gantt/filetejs/')
const PMGanttModules = [{
  path: 'pm/gantt',
  name: 'PMGanttContainer',
  component: PMGanttContainer
}
]

// family
const FamilyContainer = () => import(/* webpackChunkName: "FamilyContainer" */ 'src/components/family/filetejs/')
const FamilyEditor = () => import(/* webpackChunkName: "FamilyEditor" */ '@/components/family/filetejs/editor/Editor.vue')
const familyModules = [{
  path: 'family',
  name: 'FamilyContainer',
  component: FamilyContainer
}, {
  path: 'family/:mode/:id',
  name: 'FamilyEditor',
  component: FamilyEditor
}]

const appsModules = []
  .concat(familyModules)
  .concat(PMProjectModules)
  .concat(PMTopicModules)
  .concat(PMTaskModules)
  .concat(PMGanttModules)
  .concat(PMTaskSorterModules)
  .concat(AppsCatalystModules)
  .concat(AppsLinksModules)
  .concat(AppsCommon)

const adminModules = [{
  path: 'invite',
  name: 'invite',
  component: Invite
}].concat(userModules)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Login
    }, {
      path: '/login',
      name: 'Login',
      component: LoginOauth
    }, {
      path: '/root',
      name: 'Root',
      component: DashboardLayout,
      children: companyModules.concat(administratorsModules)
    }, {
      path: '/apps',
      name: 'Apps',
      component: DashboardLayout,
      children: appsModules
    }, {
      path: '/dashboard',
      name: 'Dashboard',
      component: DashboardLayout,
      children: [{
        path: 'overview',
        name: 'Overview',
        component: Overview
      }]
    }, {
      path: '/admin',
      name: 'Admin',
      component: DashboardLayout,
      children: adminModules
    }, {
      path: '/users',
      name: 'users',
      component: ExternalLayout,
      children: [{
        path: 'password-reset/:token?',
        name: 'passwordReset',
        component: PasswordReset
      }, {
        path: 'register/:token?',
        name: 'register',
        component: Register
      }]
    }, {
      path: '/edit',
      name: 'edit',
      component: DashboardLayout,
      children: [{
        path: 'family/:id',
        name: 'Family',
        component: FamilyEditor
      }]
    }, {
      path: '/demo',
      name: 'demo',
      component: DashboardLayout,
      children: [{
        path: 'demo4',
        name: 'Demo4', // family / sort
        component: Demo4
      }]
    }, {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    }, {
      path: '*',
      component: NotFoundPage
    }]
})

// router.beforeEach((to, from, next) => {
//   // console.log('>>> beforeEach', to, from)
//   next()

//   // esto falla
//   // if (to.matched.some(record => ['/login'].indexOf(record.path) !== -1)) { // @todo cambiar por nombre a login
//   //   console.log('>>> beforeEach, /login next')
//   //   next()
//   // } else {
//   //   console.log('>>> beforeEach, /xxxx check localStorage', localStorage)
//   //   // requires login
//   //   if (localStorage.getItem('feathers-jwt') && localStorage.getItem('feathers-jwt-exp')) {
//   //     if (parseFloat(localStorage.getItem('feathers-jwt-exp')) * 1000 > Date.now()) {
//   //       // ok logged (soft)
//   //       next()
//   //     } else {
//   //       next({ name: 'Login' })
//   //     }
//   //   } else {
//   //     next({ name: 'Login' })
//   //   }
//   //   // console.log('>>> stop: localStorage', localStorage['feathers-jwt'])
//   // }
// })

export default router
